import { apiClient } from '@/shared/lib/axios';
import { getApiErrorMessage } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';

export const useAdminInsurerAttentionBulkDelete = (onSuccess?: () => void) => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: number[]) =>
      apiClient.post(`/admin/${siteType}/insurer-attentions/bulk-delete`, { ids }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-insurer-attentions', siteType] });
      toast.success('削除しました。');
      onSuccess?.();
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, '削除に失敗しました。'));
    },
  });
};
